import React from 'react';
import styles from './PerfectMatchView.module.css';

const PerfectMatchView: React.FC = () => {
  const openQualityCheck = () => {
    window.location.hash = '#quality-check';
  };

  const openCategoryExplorer = () => {
    window.location.hash = '#category-explorer';
  };

  return (
    <section className={styles.root}>
      <header className={styles.header}>
        <h2 className={styles.title}>Perfect Match Workflow</h2>
      </header>

      <div className={styles.grid}>
        <div className={styles.panel}>
          <h3 className={styles.panelTitle}>A Discovery Phase</h3>
          <p className={styles.panelText}>
            Use the Category Explorer to identify obvious and not so obvious book award categories you could apply for.
          </p>
          <button type="button" className={styles.discoveryButton} onClick={openCategoryExplorer}>
            Start Discovery
          </button>
        </div>

        <div className={styles.panel}>
          <h3 className={styles.panelTitle}>B Filtering Phase</h3>
          <p className={styles.panelText}>
            Compare Book Award Programs, Requirements and Past Winners. Check Timeline, Fees and Eligibility Criteria to narrow down your perfect matches.
          </p>
          <button type="button" className={styles.filterButton} onClick={openQualityCheck}>
            Start Filtering
          </button>
        </div>

        <div className={styles.panel}>
          <h3 className={styles.panelTitle}>C Ranking Phase</h3>
          <p className={styles.panelText}>
            Evaluate finalist awards based on prestige, submission complexity, and win probability. Assign priority scores and create your submission roadmap.
          </p>
          <button type="button" className={styles.rankButton} onClick={openQualityCheck}>
            Start Ranking
          </button>
        </div>
      </div>
    </section>
  );
};

export default PerfectMatchView;
